import { render, staticRenderFns } from "./searchDataByStudent.vue?vue&type=template&id=52bb37d6&scoped=true"
import script from "./searchDataByStudent.vue?vue&type=script&lang=js"
export * from "./searchDataByStudent.vue?vue&type=script&lang=js"
import style0 from "./searchDataByStudent.vue?vue&type=style&index=0&id=52bb37d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb37d6",
  null
  
)

export default component.exports